import React, { useEffect, useRef, useState } from 'react';

import { useHistory } from 'react-router-dom';


import { connect } from 'react-redux';
import { withRouterAndRef } from 'services/utils';
import { updateChangeSupportAccess } from 'actions';

import MenuPrincipal from '../../MenuPrincipal';

import { FiAlignJustify } from 'react-icons/fi';

import NiceModal from '@ebay/nice-modal-react';
import { cloneModalAccessSupport } from 'pctComponents/modals/ModalSupport';


import { exitSupportAccess } from 'services/utils';


function HeaderMenuPrincipal({
    hasEnrollmentRequests,
    userIsInCampaign,
    externalcourses,
    menuStyle,
    supportAccessChangeStatus,
    updChangeSupportAccess,
}) {
    const didMount = useRef(false);
    const childFunctionRef = useRef();
    const [menuStatus, setMenu] = useState(false);

    const history = useHistory();

    const showModalAccessSupport = () => {
        NiceModal.show(cloneModalAccessSupport({ updChangeSupportAccess }), {
            adminProps: {},
            updChangeSupportAccess: updChangeSupportAccess,
        });
    };

     const closeSupportAccess = () => {
    
        exitSupportAccess({
            handleExitSupportAccess: () => {
                childFunctionRef.current.resetMenu();
                history.push('/');
            },
        });
    }

    useEffect(() => {
        if (didMount.current) {
            if (supportAccessChangeStatus && childFunctionRef.current) {
                childFunctionRef.current.resetMenu();
            }
        } else {
            didMount.current = true;
        }
    }, [supportAccessChangeStatus]);

    return (
        <>
            <button
                className={`menuHeader ${menuStyle}`}
                onClick={() => {
                    menuStatus ? setMenu(false) : setMenu(true);
                }}
            >
                <FiAlignJustify />
            </button>

            <MenuPrincipal
                hasEnrollmentRequests={hasEnrollmentRequests}
                isInCampaign={userIsInCampaign}
                externalcourses={externalcourses}
                expanded={menuStatus}
                expand={() => {
                    setMenu(false);
                }}
                menuData={() => {
                    return [];
                }}
                ref={childFunctionRef}
                showModalAccessSupport={showModalAccessSupport}
                closeSupportAccess={closeSupportAccess}
            />
        </>
    );
}


const mapDispatchToProps = (dispatch) => ({
    updChangeSupportAccess: (item) => dispatch(updateChangeSupportAccess(item)),
});

const mapStateToProps = (store) => ({
    supportAccessChangeStatus: store.supportAccessState,
});

export default withRouterAndRef(connect(mapStateToProps, mapDispatchToProps)(HeaderMenuPrincipal));

